module.exports = __webpack_public_path__ + "fonts/Satoshi-Regular.5b76e2f.woff2";